import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const PencilIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m19.71 8.04-2.34 2.33-3.75-3.75 2.34-2.33c.39-.39 1.04-.39 1.41 0l2.34 2.34c.39.37.39 1.02 0 1.41zM3 17.25 13.06 7.18l3.75 3.75L6.75 21H3v-3.75zM16.62 5.04l-1.54 1.54 2.34 2.34 1.54-1.54-2.34-2.34zM15.36 11 13 8.64l-9 9.02V20h2.34l9.02-9z"
          fill="#4C4191"
        />
      </svg>
    </SvgIcon>
  );
};

export default PencilIcon;
